import type { CompInfo } from '@wix/thunderbolt-becky-root'
import { getScaledFont } from '@wix/thunderbolt-becky-root'
import type { ComboBoxInputDefinition } from './ComboBoxInput'
import { textPaddingLimit } from './contants'

type BeckyTextAlignment = 'left' | 'center' | 'right'

export const getTextPaddingObject = ({
	textAlignment,
	textPadding,
}: {
	textAlignment: BeckyTextAlignment
	textPadding: number
}) => {
	const textPaddingPx = `${textPadding ?? textPaddingLimit}px`

	const textPaddingLimitPx = `${textPaddingLimit}px`

	switch (textAlignment) {
		case 'left':
			return {
				'--textPadding': `0 ${textPaddingLimitPx} 0 ${textPaddingPx}`,
			}
		case 'right':
			return {
				'--textPadding': `0 ${textPaddingPx} 0 ${textPaddingLimitPx}`,
			}
		case 'center':
			return {
				'--textPadding': `0 ${textPaddingLimitPx} 0 ${textPaddingLimitPx}`,
			}
		default:
			return {}
	}
}

export const getCrossEditorsCssVars = (
	compInfo: Pick<CompInfo, 'compLayout' | 'styleProperties' | 'siteFonts' | 'isMobileView'>,
	{
		textAlignment,
		inputMobileFontSize,
		textPadding,
	}: Pick<ComboBoxInputDefinition['property'], 'textAlignment' | 'inputMobileFontSize' | 'textPadding'>,
	isOneDocMigrated: boolean
) => ({
	'--dir': textAlignment === 'right' ? 'rtl' : 'ltr',
	'--textAlign': textAlignment,
	'--fnt': getScaledFont(compInfo, 'fnt', isOneDocMigrated, inputMobileFontSize),
	...getTextPaddingObject({ textAlignment: textAlignment!, textPadding: textPadding! }),
})
